import { ActivityIndicator } from "react-native";

export default function ButtonLoadingSpinner() {
  return <ActivityIndicator style={{ display: "flex" }} color="black" size="large" />;
}
